import React from "react";

const Footer = () => {
  return (
    <footer className="">
    </footer>
  );
};

export default Footer;
